<template>
	<div class="container">
		<h4>{{ title }}</h4>
		<Divider dashed />
		<Form
			ref="blood-config-form"
			:model="bloodConfigForm"
		>
			<Row :gutter="20" class="item" v-for="(item, index) in bloodConfigForm.inputs" :key="index">
				<Col span="7">
					<FormItem
						:prop="'inputs.' + index + '.name'"
						:rules="{
							required: false,
							message: '请填写输入名称'
						}"
					>
						<label class="display-block">输入</label>
						<Input
							type="text"
							v-model="item.name"
							placeholder="正在建设中…"
							disabled
						/>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem
						:prop="'inputs.' + index + '.description'"
						:rules="{
							required: false,
							message: '请填写任务描述'
						}"
					>
						<label class="display-block">任务描述</label>
						<Input
							type="text"
							placeholder="任务描述"
							v-model="item.description"
							disabled
						/>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem
						:prop="'inputs.' + index + '.runner'"
						:rules="{
							required: false,
							message: '请选择执行人'
						}"
					>
						<label class="display-block">执行人</label>
						<Select
							placeholder="负责人"
							v-model="item.runner"
							disabled
						>
							<!-- <Option
								v-for="(item, index) in executor"
								:value="item.id"
								:key="item.id"
							>{{ item.name }}</Option> -->
						</Select>
					</FormItem>
				</Col>
				<Icon
				    type="md-add"
				    class="icon-add"
				    size="16"
				    @click="handleAdd"
				></Icon>
				<Icon
					v-if="index"
					type="md-remove"
					class="icon-remove"
					size="16"
					@click="handleRemove(index)"
				></Icon>
			</Row>
			<Row :gutter="20" class="item">
				<Col span="7">
					<FormItem
						:prop="'output.name'"
						:rules="{
							required: false,
							message: '请填写输出名称'
						}"
					>
						<label class="display-block">输出</label>
						<Input
							type="text"
							v-model="bloodConfigForm.output.name"
							placeholder="正在建设中…"
							disabled
						/>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem
						:prop="'output.description'"
						:rules="{
							required: false,
							message: '请填写任务描述'
						}"
					>
						<label class="display-block">任务描述</label>
						<Input
							type="text"
							placeholder="任务描述"
							v-model="bloodConfigForm.output.description"
							disabled
						/>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem
						:prop="'output.runner'"
						:rules="{
							required: false,
							message: '请选择执行人'
						}"
					>
						<label class="display-block">执行人</label>
						<Select
							placeholder="负责人"
							v-model="bloodConfigForm.output.runner"
							disabled
						>
							<!-- <Option
								v-for="(item, index) in executor"
								:value="item.id"
								:key="item.id"
							>{{ item.name }}</Option> -->
						</Select>
					</FormItem>
				</Col>
			</Row>
		</Form>
	</div>
</template>

<script>
	export default {
		props: {
			blood: {
				type: Object,
				default: new Object()
			}
		},
		data() {
			return {
				title: "血缘配置",
				bloodConfigForm: {
					inputs: [
						{
							name: "",
							description: "",
							runner: ""
						}
					],
					output: {
						name: "",
						description: "",
						runner: ""
					}
				}
			};
		},
		methods: {
			handleAdd() {
				return this.$Message.info("正在建设中…");
				
				this.bloodConfigForm.inputs.push({
					name: "",
					description: "",
					runner: ""
				});
			},
			handleRemove(i) {
				this.bloodConfigForm.inputs = this.bloodConfigForm.inputs.filter((item, index) => index != i);
			}
		},
		created() {
			let {
				inputs,
				output
			} = this.bloodConfigForm;
			
			this.blood.inputs = inputs;
			
			this.blood.output = output;
		}
	};
</script>

<style scoped>
	.icon-add,
	.icon-remove {
		position: absolute;
		top: 40px;
		cursor: pointer;
	}
	
	.icon-add {
		right: 60px;
	}
	
	.icon-remove {
		right: 10px;
	}
</style>
